import React from 'react';
import { styled, keyframes } from '@compiled/react';

import { token } from '@atlaskit/tokens';

type SkeletonProps = {
	lineCount?: number;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const AutomationSkeletonContainer = styled.div({
	padding: `${token('space.025')} 0`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SkeletonContainer = styled.div({
	margin: `${token('space.100')} ${token('space.250')}`,
	display: 'flex',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SkeletonIcon = styled.div({
	width: '16px',
	height: '16px',
	display: 'inline-block',
	borderRadius: token('radius.xsmall'),
	backgroundColor: 'currentColor',
	border: `${token('border.width.selected')} solid transparent`,
	opacity: 0.15,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const MenuIcon = styled.div({
	width: '24px',
	height: '24px',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
});

const shimmer = keyframes({
	'0%': {
		backgroundPosition: '-300px 0',
	},
	'100%': {
		backgroundPosition: '2000px 0',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SkeletonText = styled.div({
	width: '85%',
	height: token('space.200'),
	marginTop: token('space.050'),
	marginLeft: token('space.150'),
	animationDuration: '1s',
	animationFillMode: 'forwards',
	animationIterationCount: 'infinite',
	animationName: shimmer,
	animationTimingFunction: 'linear',
	backgroundColor: token('color.skeleton'),
	backgroundImage: `linear-gradient(to right, ${token('color.skeleton')} 10%, ${token('color.skeleton.subtle')} 30%, ${token('color.skeleton')} 50%)`,
	backgroundRepeat: 'no-repeat',
});

const SkeletonLine: () => JSX.Element = () => (
	<SkeletonContainer>
		<MenuIcon>
			<SkeletonIcon />
		</MenuIcon>
		<SkeletonText />
	</SkeletonContainer>
);
const getSkeletonLines = (lineCount: number) => {
	const skeletonLines = [];
	for (let i = 0; i < lineCount; i++) {
		skeletonLines.push(<SkeletonLine key={`skeleton-line-${i}`} />);
	}
	return skeletonLines;
};

export const Skeleton = (props: SkeletonProps) => {
	const { lineCount = 5 } = props;
	return <AutomationSkeletonContainer>{getSkeletonLines(lineCount)}</AutomationSkeletonContainer>;
};
